// extracted by mini-css-extract-plugin
var _1 = "ECmW_ORxTxmHEYKfYneZ";
var _2 = "F7vsfIFy7ppUCS0FBfsg";
var _3 = "B6fRj71jV_VCf7QwtiiQ";
var _4 = "wMrgAUfQ4CVJyjXjWLrw";
export { _1 as "company", _2 as "container", _3 as "description", _4 as "details" }
